import React from 'react';

const ResourceCard = () => {
  return (
    <div
      className="header-dropdown-card-wrapper ptb--10 plr--10"
      onClick={() => {
        window.location.href = 'https://blogs.noctil.com/';
      }}
    >
      <div className="header-dropdown-card-item-wrapper">
        <img src={'/assets/images/icons/blog.svg'} alt={'noctil-blogs'} />
        <span className={`ptb--5 plr--5 solutions-link-card-item font--16`}>
          <a href={`https://blogs.noctil.com/`}>Blogs</a>
        </span>
      </div>
    </div>
  );
};

export default ResourceCard;
